var map = {
	"./PEFC-certified.svg": 3,
	"./anti-allergic.svg": 4,
	"./arrow-footer.svg": 5,
	"./arrow-select-rotated.svg": 6,
	"./arrow-select.svg": 7,
	"./arrow.svg": 8,
	"./award-ribbon.svg": 9,
	"./award.svg": 10,
	"./chat.svg": 11,
	"./check.svg": 12,
	"./checked.svg": 13,
	"./checked2.svg": 14,
	"./clean.svg": 15,
	"./clock.svg": 16,
	"./close.svg": 17,
	"./design.svg": 18,
	"./diamant.svg": 19,
	"./download.svg": 20,
	"./dropdown-arrow.svg": 21,
	"./environmentally-friendly.svg": 22,
	"./faq.svg": 23,
	"./filter.svg": 24,
	"./heatproof.svg": 25,
	"./help.svg": 26,
	"./leaf.svg": 27,
	"./lightfast.svg": 28,
	"./low-emissions.svg": 29,
	"./mail.svg": 30,
	"./non-slip.svg": 31,
	"./pd-anti-allergic.svg": 32,
	"./pd-antistatic-dirt-repellent-easy-clean.svg": 33,
	"./pd-award-ribbon.svg": 34,
	"./pd-design.svg": 35,
	"./pd-dimensions.svg": 36,
	"./pd-easy-assemble.svg": 37,
	"./pd-guarantee.svg": 38,
	"./pd-heat-resistant.svg": 39,
	"./pd-impact-sound.svg": 40,
	"./pd-information.svg": 41,
	"./pd-integrated-insulation.svg": 42,
	"./pd-lightfast.svg": 43,
	"./pd-material.svg": 44,
	"./pd-quiet.svg": 45,
	"./pd-resilient.svg": 46,
	"./pd-strength.svg": 47,
	"./pd-usage-class.svg": 48,
	"./pd-walking-sound.svg": 49,
	"./pd-water-resistant.svg": 50,
	"./phone.svg": 51,
	"./play.svg": 52,
	"./print.svg": 53,
	"./resilient.svg": 54,
	"./sample.svg": 55,
	"./search.svg": 56,
	"./shopping-planer.svg": 57,
	"./thumb-up.svg": 58,
	"./tree-rings.svg": 59,
	"./tree.svg": 60,
	"./uncomplicated.svg": 61,
	"./water-drop.svg": 62
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2;